export function signInRequest(cpf, senha) {
  return { type: '@doctor/SIGN_IN_REQUEST', payload: { cpf, senha } };
}

export function signInSuccess(token, doctor) {
  return { type: '@doctor/SIGN_IN_SUCCESS', payload: { token, doctor } };
}

export function signInRequestExt(cpf, senha) {
  return { type: '@doctor/SIGN_IN_REQUEST_EXT', payload: { cpf, senha } };
}

export function signFailure(message) {
  return { type: '@doctor/SIGN_FAILURE', payload: { message } };
}

export function signOutMed() {
  return { type: '@doctor/SIGN_OUT' };
}
